// src/components/StyledAppBar.jsx
import { AppBar } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    boxShadow: "none",
}));

export default StyledAppBar;
